import { useParams } from 'react-router-dom'
import { useCallback, useState } from 'react'

import { Forms } from '../../../../../../../components/Forms'
import { Form } from 'antd'
import { FloatFooter } from '../../../../../../../components/FloatFooter/FloatFooter'
import { initialState } from '../../../../../../../pages/AddGpo/constants'

import useRouter from '../../../../../../../hooks/useRouter'
import { routes } from '../../../../../../../router'
import { Popup } from '../../../../../../../components/Popup'
import { Button, BUTTON_TYPES } from '../../../../../../../components/Button'
import { BTN_TXT } from '../../../../../../../constants'
import { Typography } from '../../../../../../../components/Typography'

export const EditHospitalDetails = ({ details, handleHospitalForEdit }) => {
  const { hospitalId, id } = useParams()
  const { navigate } = useRouter()

  const [form] = Form.useForm()

  const [isActive, setIsActive] = useState(false)
  const [isConfirmation, setIsConfirmation] = useState(false)
  const [isDepartmentsChanged, setIsDepartmentsChanged] = useState(false)

  const handleCallback = () => {
    setIsActive(false)
    if (hospitalId !== 'new') {
      handleHospitalForEdit()
    } else {
      navigate(
        `${routes.myCommunity}${routes.myOrganization}/health_systems/${id}`
      )
    }
  }

  const changesHandler = () => {
    setIsActive(true)
  }

  const handleCancelForm = useCallback(() => {
    if (hospitalId !== 'new') {
      form.setFieldsValue({
        ...details,
        departments: details.departments.map((i) => ({
          label: i.name,
          value: i.uuid
        })),
        ...details?.address
      })
    } else {
      form.setFieldsValue(initialState)
    }
  }, [form, details, hospitalId])

  const submitCancellation = () => {
    handleCancelForm()
    setIsActive(false)
  }

  const handleCloseConfirmation = () => setIsConfirmation(false)
  const handleOpenConfirmation = () => {
    if (hospitalId === 'new') {
      handleSubmit()
    } else {
      setIsConfirmation(true)
    }
  }

  const handleSubmit = () => {
    setIsConfirmation(false)
    form.submit()
  }

  return (
    <>
      <Forms.AddEditHospital
        callback={handleCallback}
        onChange={changesHandler}
        data={details}
        hsId={id}
        form={form}
        setIsActive={setIsActive}
        setIsDepartmentsChanged={setIsDepartmentsChanged}
      />
      <Popup
        visible={isConfirmation}
        onCancel={handleCloseConfirmation}
        title={'Save changes to Hospital?'}
        width={442}
        footer={
          <>
            <Button
              type={BUTTON_TYPES.DEFAULT}
              onClick={handleCloseConfirmation}
              upperCase
            >
              {BTN_TXT.CANCEL}
            </Button>
            <Button
              type={BUTTON_TYPES.PRIMARY}
              onClick={handleSubmit}
              upperCase
            >
              {BTN_TXT.SAVE}
            </Button>
          </>
        }
      >
        <Typography.Body1>
          {isDepartmentsChanged
            ? 'Departments removed at the Hospital level will also be automatically deleted from Hospital users profiles if used there.'
            : 'Do you want to proceed?'}
        </Typography.Body1>
      </Popup>
      <FloatFooter
        isActive={isActive}
        onCancel={submitCancellation}
        onSave={handleOpenConfirmation}
        isSaveDisabled={!isActive}
      />
    </>
  )
}
